import ScalarCodeBlockCopy_vue_vue_type_script_setup_true_lang_default from "./ScalarCodeBlockCopy.vue.script.js";
//#region src/components/ScalarCodeBlock/ScalarCodeBlockCopy.vue
var ScalarCodeBlockCopy_default = ScalarCodeBlockCopy_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarCodeBlockCopy_default as default };

//# sourceMappingURL=ScalarCodeBlockCopy.vue.js.map